module.exports = "<div  style='text-align: center; height: 450px;'>\r\n    <p>Waiting for authorization…</p>\r\n   \r\n</div>"